import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

document.addEventListener('DOMContentLoaded', () => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container) => {
        const slideCount = container.querySelectorAll('.swiper-slide').length;
        if (slideCount === 0) return;

        const enableAutoplay = container.dataset.swiperAutoplay === 'true';
        const enablePagination = container.dataset.swiperPagination === 'true';

        // swiperを適用する全要素共通の設定
        const config = {
            loop: slideCount > 2,
            speed: 1000,
            initialSlide: 0,
            slidesPerView: 1,
            touchEventsTarget: 'container',
            spaceBetween: 30,
            centeredSlides: true,
        };

        if (enableAutoplay) {
            config.autoplay = {
                delay: 8000,
                disableOnInteraction: false,
            };
        }

        if (enablePagination) {
            const pagination = container.querySelector('.swiper-pagination');
            const nextButton = container.querySelector('.swiper-button-next');
            const prevButton = container.querySelector('.swiper-button-prev');
            if (pagination) {
                config.pagination = {
                    el: pagination,
                    clickable: true,
                };
            }
            if (nextButton && prevButton) {
                config.navigation = {
                    nextEl: nextButton,
                    prevEl: prevButton,
                };
            }
        }

        new Swiper(container, config);
    });
});

